
































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { tickets } from '@/modules/shared/shared/store/namespaces';
import * as PDT_INTERFACE from './tickets-form/interfaces/PDT.interface';
import {
    getDate,
    getTimeFromDate,
} from '@/modules/shared/shared/domain/functions/date-functions.ts';

@Component({
    methods: {
        getDate,
        getTimeFromDate,
    },
})
export default class PDT extends Vue {
    showPDT: boolean = false;

    PDTDetail: PDT_INTERFACE.PDTInterface = {} as PDT_INTERFACE.PDTInterface;

    mounted() {
        this.PDTDetail = this.ticketDetail;
        this.showPDT = true;
    }
    print() {
        window.print();
    }
    checkDataCenter(id: number) {
        return this.PDTDetail.accessPermission.dataCenter.id == id;
    }

    get getOtherMotive() {
        let filteredMotives: PDT_INTERFACE.accessPermissionMotivesInterface[] = this.PDTDetail.accessPermission.accessPermissionMotives.filter(
            motive => motive.accessPermissionTypeMotive.accessMotive.id == 20,
        );
        let otherMotive =
            filteredMotives.length > 0 ? filteredMotives[0].accessMotiveDescription : '';
        return otherMotive == undefined ? '' : otherMotive;
    }

    checkAccessMotive(id: number) {
        return this.PDTDetail.accessPermission.accessPermissionMotives.some(
            motive => motive.accessPermissionTypeMotive.accessMotive.id == id,
        );
    }

    checkAccessType(id: number) {
        return this.PDTDetail.accessPermission.accessPermissionMotives.some(
            motive => motive.accessPermissionTypeMotive.accessType.id == id,
        );
    }

    get getServiceTasks() {
        return this.getTasksById(1);
    }

    get getDataCenterTasks() {
        return this.getTasksById(2);
    }

    getTasksById(id: number) {
        let tasks: PDT_INTERFACE.tasksInterface[] = Array();
        this.PDTDetail.accessPermission.tasks.forEach(task => {
            if (task.taskType.id == id) {
                tasks.push(task);
            }
        });
        return tasks;
    }

    get getAuthorizedPeople() {
        let authorizedPeople: PDT_INTERFACE.accessContactsInterface[] = Array();
        let contactType: number[] = [2, 4];
        this.PDTDetail.accessPermission.accessContacts.forEach(contact => {
            if (
                contact.contactDetails.some(detail =>
                    contactType.some(type => detail.contactType.id == type),
                )
            ) {
                authorizedPeople.push(contact);
            }
        });
        authorizedPeople.forEach(person => {
            if (person.contactDetails.some(detail => detail.contactType.id == 2)) {
                person.company = this.PDTDetail.customer.name;
            }
        });
        return authorizedPeople;
    }

    getEmail(authorizedContact: PDT_INTERFACE.accessContactsInterface) {
        return authorizedContact.email;
    }

    getPhone(authorizedContact: PDT_INTERFACE.accessContactsInterface) {
        return authorizedContact.phone;
    }

    getCI(authorizedContact: PDT_INTERFACE.accessContactsInterface) {
        return authorizedContact.identification;
    }

    getFullName(authorizedContact: PDT_INTERFACE.accessContactsInterface) {
        return authorizedContact.name + ' ' + authorizedContact.lastName;
    }

    getSpecificContact(
        contactType: number,
        accessContacts: PDT_INTERFACE.accessContactsInterface[],
    ) {
        let authorizedContact: PDT_INTERFACE.accessContactsInterface = {} as PDT_INTERFACE.accessContactsInterface;
        accessContacts.forEach(contact => {
            if (contact.contactDetails.some(detail => detail.contactType.id == contactType)) {
                authorizedContact = contact;
            }
        });
        return authorizedContact;
    }

    getMovementType(id: number) {
        return id == 1 ? 'Ingreso' : 'Egreso';
    }

    @tickets.State('ticketDetail') ticketDetail;
}
